import {ModuleProto} from "../module-proto"
import {ModuleType} from "../types"
import {SettingsMenuTopCategory} from "../settings-module"
import {SettingsParentSection} from "../../../app/settings/const"
import {Feature} from "../../gd/access-control/feature-access/const"

const COMPANIES_AVAILABLE_IN : ID[] = ['89d5pB', 'PGUOPE','U48GJt']
// const COMPANIES_AVAILABLE_IN : ID[] = []

// const debug = "ExternalDataModule"
const debug = false

export class ModuleCustomEntities extends ModuleProto {

    constructor(moduleConfig: any) {
        super(ModuleType.CUSTOM_ENTITIES, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                       = "Custom Entities"
        this.description                = "The External Datasource allows you to access and interact with real-time data from external sources in a clear, organized format."
        this.svgIcon                    = "isvg-data-storage"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                  = "Automations"
        this.settingsUrl                = "settings/external-data"
        this.parentSection              = SettingsParentSection.AUTOMATIONS

        /**--- development state config only [START]---**/
        const isAvailable               = COMPANIES_AVAILABLE_IN.includes(gd.companyId)
        this.isComingSoon               = !isAvailable
        this.hasStatus                  = isAvailable

        this.canDisable                 = isAvailable
        this._isEnabled                 = isAvailable
        /**--- development state config only [END]---**/

        // release state config
        // this.canDisable                 = true
        // this._isEnabled                 = _.get(moduleConfig, 'isEnabled', false)

        this.feature                    = Feature.CUSTOM_ENTITY
        this.validateFeature()
    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}